import React from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer';
import EMICalculator from '../../components/emi-calculator';

const EMICalculatorPage: React.FC = () => {
    return (
        <div className="bg-slate-50 min-h-screen">
            <Navbar transparent={false} />
            
            {/* Page Header */}
            <div className="relative pt-6 md:pt-10 pb-6 md:pb-10 bg-white border-b border-slate-100 overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full opacity-5">
                    <div className="absolute top-10 left-10 w-64 h-64 bg-[#001b4a] rounded-full blur-3xl"></div>
                    <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#f1ae24] rounded-full blur-3xl"></div>
                </div>
                
                <div className="container px-6 relative z-10">
                    <div className="max-w-4xl">
                        <nav className="flex items-center gap-2 text-slate-400 text-xs font-medium tracking-wide mb-1 md:mb-2">
                            <span>Tools</span>
                            <i className="fa-solid fa-chevron-right text-[8px]"></i>
                            <span className="text-[#001b4a]">EMI Calculator</span>
                        </nav>
                        
                        <h1 className="text-3xl md:text-5xl font-bold text-[#001b4a] mb-2 md:mb-4 leading-tight">
                            Mortgage <span className="text-[#f1ae24]">EMI</span> Calculator
                        </h1>
                        <p className="text-slate-500 text-base font-medium max-w-2xl leading-relaxed">
                            Empowering your property journey with precision. Visualize your home loan repayment roadmap and plan your future with our advanced financial engine.
                        </p>
                    </div>
                </div>
            </div>
            
            {/* Calculator Section */}
            <section className="py-6 md:py-8 -mt-10 relative z-20">
                <div className="container px-6">
                    <div className="max-w-6xl mx-auto">
                        <EMICalculator initialAmount={5000000} />
                        
                        {/* Summary / Educational Content Below Tool */}
                        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-graduation-cap text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">How it works?</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    Our calculator uses the standard reducing balance method to calculate your Monthly Installments (EMI). It factors in the principal amount, interest rate, and tenure to provide a precise roadmap.
                                </p>
                            </div>
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-chart-line text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">Maximize Savings</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    Understand the impact of interest over time. A shorter tenure or slightly lower interest rate can save you lakhs of rupees in total interest payable over the loan period.
                                </p>
                            </div>
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-shield-halved text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">Secure Planning</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    Planning ahead ensures financial security. Use our amortization schedule to see exactly how your balance reduces year by year, helping you manage pre-payments effectively.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <Footer />
        </div>
    );
};

export default EMICalculatorPage;
